module.exports = __webpack_public_path__ + "assets/c1b95693db6c45173bb6d228818d4619.mp3";